import { connect } from "react-redux";

var NumbersOnlyInput = require("components/utility/NumbersOnlyInput");
var ReadingActions = require("lib/actions/ReadingActions");
var BookDisplay = require("components/reading/books/BookDisplay")
var DropDownOptions = require("components/utility/DropDownOptions");
var BookLogger = require("components/reading/books/BookLogger");

var CurrentUser = require("lib/account/CurrentUser");
var moment = require('moment');
var RosterActions = require("lib/actions/RosterActions");
var RosterSelectors = require("lib/selectors/RosterSelectors");
var ReadingSelectors = require("lib/selectors/ReadingSelectors");
var ReadingLevelIcon = require("components/reading/reading_levels/ReadingLevelIcon");
var Glyphicon = require("components/utility/icons/Glyphicon");
var ReactTooltip = require("react-tooltip");

require("reading/logs/log_table.scss");

@connect(
	(state, props) => ({
		book: ReadingSelectors.book({ state, id: props.log.text_id }),
		student: RosterSelectors.student({ state, id: props.log.user_id })
	}),
	(dispatch, props) => ({
		onDelete: () => dispatch(ReadingActions.deleteLog({ id: props.log.id })),
		onUpdate: (updateData) => dispatch(ReadingActions.updateLog({
			id: props.log.id, update: updateData
		})),
		onInclude: (updateData) => dispatch(ReadingActions.updateLog({
			id: props.log.id, update: { excluded: false }
		})),
		onExclude: (updateData) => dispatch(ReadingActions.updateLog({
			id: props.log.id, update: { excluded: true }
		})),
		fetchBook: () => dispatch(ReadingActions.batchFetchBook(
			{ id: props.log.text_id, userID: (CurrentUser.get() || {}).id }
		)),
		fetchStudent: () =>dispatch(RosterActions.fetchStudent({
			id: props.log.user_id, query, embeds: "student.current_reading_level"
		}))
	})
)
class LogRow extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			editField: false,
			errors: []
		}
	}

	onClickEditField(e) {
		$wr.nope(e)
		this.setState({ editField: true })
	}

	onSubmit(e) {
		$wr.nope(e)

		var newMinutes = this.refs.newMinutesInput.number() || 0;
		var newPages = this.refs.newPagesInput.number() || 0;
		var errors = []
		
		if (newMinutes > BookLogger.MAX_LOG_MINUTES) {
			errors.push("minutes");
		}
		if (newPages > BookLogger.MAX_LOG_PAGES) {
			errors.push("pages");
		}

		if (errors.length > 0) {
			this.setState({ errors })
		} else {
			if (this.refs.newLocationInput) {
				var newLocation = this.refs.newLocationInput.value;
			}

			if (newMinutes == 0 && newPages == 0) {
				this.props.onDelete();
			} else {
				this.props.onUpdate({ minutes: newMinutes, pages: newPages, location: newLocation });
				this.setState({ editField: false, errors: [] });
			}
		}
		
	}

	deleteLog(e) {
		$wr.nope(e)
		if (confirm("Are you sure you want to delete this reading log?")) {
			window.wrNotifications.triggerDropDownNotification({
				title: "Log Deleted", text: "You have deleted the log.", icon: "trash" });
			this.props.onDelete();
		}
	}

	includeLog(e) {
		$wr.nope(e)
		if (confirm("This will allow this reading log to count toward your custom goals. Are you sure?")) {
			window.wrNotifications.triggerDropDownNotification({
				title: "Log Included", text: "You have included this reading log.", icon: "ok-sign" });
			this.props.onInclude();
		}
	}
	excludeLog(e) {
		$wr.nope(e)
		if (confirm("This will exclude this reading log from counting toward your custom goals. Are you sure?")) {
			window.wrNotifications.triggerDropDownNotification({
				title: "Log Excluded", text: "You have excluded this reading log.", icon: "ok-sign" });
			this.props.onExclude();
		}
	}

	getLocationOptions() {
		return DropDownOptions.Select.Locations();
	}

	render() {
		var day = moment(this.props.log.log_date).format("ddd, MMM D");
		var dateCell = (
			<td className="dateCell">
				<div className="infoContainer">{ day }</div>
				<span className="sectionLabel">Date</span>
			</td>
		);
		var titleCell = (
			<td className="titleCell">
				<div className="infoContainer textTitle">
					<BookDisplay textID={ this.props.log.text_id } />
				</div>
				<span className="sectionLabel">
					Title
				</span>
			</td>
		);

		if (this.props.book && this.props.book.lexile_score) {
			if (CurrentUser.isAdmin()) {
				var studentReadingLevel = this.props.student.current_reading_level;
				var tooltipCopyType = ReadingLevelIcon.TEACHER_VIEW;
			} else { 
				var studentReadingLevel = CurrentUser.get().current_reading_level;
				var tooltipCopyType = ReadingLevelIcon.STUDENT_VIEW;
			}
			var readingLevelDisplay = (
				<ReadingLevelIcon studentReadingLevel={ studentReadingLevel } 
					textReadingLevel={ this.props.book.lexile_score }
					tooltipCopyType={ tooltipCopyType }
					showImageOnly />
			)
		}

		var readingLevelCell = (
			<td className="minuteCell">
				<div className="infoContainer">{ readingLevelDisplay }</div>
			</td>
		)

		if (this.state.editField) {
			var location = this.props.log.location;
			if (location) {
				dateCell = (
					<td className="dateCell">
						<div className="infoContainer">{ day }</div>
						<span className="sectionLabel dateLabel">Date</span>

						<span className="inputBox">
							<select className="form-control logLocationInput" ref="newLocationInput" 
								defaultValue={location}>
							    { this.getLocationOptions() }
							</select>
							<br /><span className="sectionLabel">Location</span>
						</span>
					</td>
				)
			}
			if ( this.state.errors.length > 0 ) {
				if (this.state.errors.includes("minutes")) {
					var minuteError = (<span className="logError">Too high!</span>)
				}
				if (this.state.errors.includes("pages")) {
					var pageError = (<span className="logError">Too high!</span>)
				}
			}
			return (
				<tr className="logRow editingLogRow">
					{ dateCell }
					{ titleCell }
					<td className="editedDataCell hideOnPrint" colSpan="3" >
						<form className="editedData" onSubmit={ this.onSubmit } >
							<span className="inputBox">
								<NumbersOnlyInput className="logMinutesInput form-control"
									defaultValue={ this.props.log.minutes } ref="newMinutesInput" />
								<br /><span className="sectionLabel">Minutes { minuteError }</span>
							</span>
							<span className="inputBox">
								<NumbersOnlyInput className="logPagesInput form-control"
									defaultValue={ this.props.log.pages } ref="newPagesInput" />
								<br /><span className="sectionLabel">Pages { pageError }</span>
							</span>
							<span className="inputBox">
								<button className="btn buttonSuccess saveButton">Save</button>
							</span>
						</form>
					</td>
				</tr>
			)

		} else {
			var startTime = this.props.log.start_time;
			if (startTime && this.props.log.location) {
				
				var day = moment(this.props.log.log_date).format("ddd, MMM D");
				var location = this.props.log.location;
				var startTimeFormatted = moment(startTime).format("h:mm a");
				var endTimeFormatted = moment(this.props.log.end_time).format("h:mm a");
				var dateCell = (
					<td className="dateCell">
						<div className="infoContainer">{ day }</div>
						<span className="sectionLabel">Date</span>

						<div className="infoContainer">{ location }</div>
						<span className="sectionLabel">Location</span>
					</td>
				)
				var timeCell = (
					<td className="dateCell">
						<div className="infoContainer">{ startTimeFormatted }</div>
						<span className="sectionLabel">Start Time</span>

						<div className="infoContainer">{ this.props.log.minutes || "-" }</div>
						<span className="sectionLabel">Minutes</span>
					</td>
				)
				var logQuantityContainer = (
					<td className="minuteCell">
						<div className="infoContainer">{ endTimeFormatted }</div>
						<span className="sectionLabel">End Time</span>

						<div className="infoContainer">{ this.props.log.pages || "-" }</div>
						<span className="sectionLabel">Pages</span>
					</td>
				)
			} else {
				var logQuantityContainer = (
					<td className="minuteCell">
						<div className="infoContainer">{ this.props.log.minutes || "-" }</div>
						<span className="sectionLabel">Minutes</span>
					</td>			
				)
				var logQuantityContainerTwo = (
					<td className="pageCell">
						<div className="infoContainer">{ this.props.log.pages || "-" }</div>
						<span className="sectionLabel">Pages</span>
					</td>
				)
			}

			if (CurrentUser.get().prefs.automatic_zpd_exclusion || this.props.log.excluded) {
				var goalsLink = (<a href="#" className="btn btn-link" onClick={ this.includeLog }>Include In Goals</a>)
			} else {
				var goalsLink = (<a href="#" className="btn btn-link" onClick={ this.excludeLog }>Exclude From Goals</a>)
			}
			var editLink = (
				<a href="#" onClick={ this.onClickEditField } className="btn btn-link">
					Edit Log
				</a>
			)
			var deleteLink = (
				<a href="#" className="btn btn-link" onClick={ this.deleteLog }>Remove Log</a>
			);
			if (CurrentUser.isAdmin()) {
				var teacherLinks = (
					<div>
						{ goalsLink }
						{ deleteLink }
					</div>
				)
			}
			var logOptions = (
				<td className="optionsCell">
					<div className="infoContainer">
						<div className="dropdown hideOnPrint">
							<a role="button" className=""
								data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
								<span className="ellipsisText btn-link">Options</span>
								<span className="caret"></span>
						  	</a>

							<ul className="dropdown-menu dropdown-menu-right" aria-labelledby="dLabel">
								{ editLink }
								{ teacherLinks }
							</ul>
						</div>
					</div>
				</td>
			)
			if (this.props.log.excluded) {
				var className = "excludedLog";
				var logTooltipText = "This log will not count toward goals."
			}

			if (this.props.log.verified) {
				var logTooltipText = "This log has parent approval."
				var parentConfirmation = (
					<td className="dateCell">
						<div className="infoContainer" data-tip={ logTooltipText }>
							<Glyphicon icon="ok-sign" />
						</div>
					</td>
				)
			}

			if (this.props.condensedLayout) {
				var day = moment(this.props.log.log_date).format("MMM D");
				return (
					<tr className="logRow digestLogRow">
						<td className="dateCell">
							<div className="infoContainer">{ day }</div>
						</td>
						<td className="titleCell">
							<div className="infoContainer textTitle">
								<BookDisplay textID={ this.props.log.text_id } />
							</div>
						</td>
						<td className="minuteCell">
							<div className="infoContainer">{ this.props.log.minutes || "-" } minutes</div>
						</td>						
					</tr>
				)
			} else {
				return (
					<tr className="logRow">
						{ dateCell }
						{ titleCell }
						{ readingLevelCell }
						{ timeCell }
						{ logQuantityContainer }
						{ logQuantityContainerTwo }
						{ parentConfirmation }
						{ logOptions }
					</tr>
				)
			}

		}
	}
};


LogRow.WrappedComponent.propTypes = StrictPropTypes({
	log: PropTypes.object.isRequired,
	condensedLayout: PropTypes.bool,
	book: PropTypes.object,
	student: PropTypes.object,

	// From @connect
	onDelete: PropTypes.func.isRequired,
	onUpdate: PropTypes.func.isRequired,
	onInclude: PropTypes.func,
	onExclude: PropTypes.func,
	fetchBook: PropTypes.func,
	fetchStudent: PropTypes.func
});

module.exports = LogRow;

 	// editCell



// WEBPACK FOOTER //
// ./modules/components/reading/logs/LogRow.js